// extracted by mini-css-extract-plugin
export default {"empty":"CollectionListingManual_empty__YkRLG"};